// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/invitations/invitations.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canCreate } from "./check";

export function useCanCreate(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canCreate(withinScope);
  return canDoAction;
}
